import React from 'react';
import useCondition from '../../../useCondition';
import useFilterModalContext from '../../useFilterModalContext';
import {XMarkIcon, ArrowRightIcon} from '@heroicons/react/20/solid';
import {useUsersByClientAllQuery} from 'api';

export default () => {
  const {setFilterType} = useFilterModalContext();
  const {condition, setCondition} = useCondition();

  const {data: {usersByClientAll: {users = []} = {}} = {}} =
    useUsersByClientAllQuery({
      variables: {
        search: {
          active: true,
        },
      },
      fetchPolicy: 'cache-and-network',
    });

  if (!condition?.users || !condition?.users.length) {
    return null;
  }

  return (
    <div className="pb-4 border-b border-c-border flex flex-col gap-2">
      <div className="flex items-center gap-1">
        <h4 className="m-0 font-bold">担当者</h4>
        <button
          onClick={() => setFilterType('user')}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <ArrowRightIcon className="w-3 h-3 text-c-light" />
        </button>
        <button
          onClick={() => setCondition({users: []})}
          className="p-0 h-5 w-5 flex items-center justify-center rounded-full border border-c-lighter cursor-pointer">
          <XMarkIcon className="w-3 h-3 text-c-light" />
        </button>
      </div>
      <div className="flex flex-wrap items-center gap-1">
        {condition?.users.find((user) => user === '0') && (
          <span className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
            未設定
          </span>
        )}
        {users
          .filter((user) => condition?.users.includes(user.id))
          .map((user) => (
            <span
              key={user.id}
              className="text-sm inline-block border border-c-border rounded-sm bg-c-bg px-2">
              {user.lastName || ''} {user.firstName || ''}
            </span>
          ))}
      </div>
    </div>
  );
};
